import React from "react";

export default function About() {
  return (
    <section id="about" className="bg-gradient-to-r from-slate-900 via-gray-900 to-slate-800 text-gray-300">
      <div className="container mx-auto flex px-10 py-24 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <div className="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wider text-green-400 uppercase bg-green-900/40 rounded-full border border-green-500/30">
            NYC Web Engineer &amp; Designer
          </div>
          <h1 className="title-font sm:text-5xl text-4xl mb-4 font-bold text-white leading-tight">
            Hi, I'm Mark.
            <br className="hidden lg:inline-block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500">
              Building exceptional web apps.
            </span>
          </h1>
          <p className="mb-8 leading-relaxed text-gray-300 text-lg">
            I am a senior web engineer and designer based in <strong>New York City</strong> with 15+ years of experience crafting high-performance, accessible, and visually stunning digital products. Specializing in <strong>React, Next.js, TypeScript, Headless WordPress</strong>, and modern UI/UX architecture.
          </p>
          <div className="flex flex-wrap gap-4 justify-center md:justify-start">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-3 px-8 focus:outline-none hover:bg-green-600 rounded-lg text-lg font-medium shadow-lg hover:shadow-green-500/20 transition-all duration-200"
            >
              Work With Me
            </a>
            <a
              href="#projects"
              className="inline-flex text-gray-300 bg-gray-800 border border-gray-700 py-3 px-8 focus:outline-none hover:bg-gray-700 hover:text-white rounded-lg text-lg font-medium transition-all duration-200"
            >
              View Projects
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 flex justify-center">
          <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl border border-gray-100 flex items-center justify-center">
            <img
              className="object-contain max-h-72 sm:max-h-80 w-auto"
              alt="MarkNYCweb - Web Development & Creative Studio Logo in New York City"
              src="./images/marknycweb_logo.png"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}